import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {FranchiseService} from 'app/blocks/service/api/franchise.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IFranchise} from 'app/blocks/model/franchise.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {Franchise} from 'app/blocks/model/franchise.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class FranchiseResource extends AbstractEntityResource<IFranchise> {
    constructor(franchiseService: FranchiseService, router: Router) {
        super(
            Resource.FRANCHISES,
            franchiseService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.FRANCHISES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.FRANCHISES),
            (entity?) => new Franchise(entity),
            (entity) => entity.code,
            'business'
        );
    }
}
